<template>
  <div :class="{'is-processing': isProgressing}">
    <el-upload
      :action="action"
      :before-upload="handleBeforeUpload"
      :on-success="handleSuccess"
      :on-error="handleError"
      :headers="headers"
      :item="item"
      :name="name" style="display:inline-block">
      <el-button size="small" type="info" v-if="!opreation">点击上传</el-button>
      <img v-if="item.image && opreation" :src="item.image"/>
      <img v-if="!item.image && opreation" src="../ico/uploadpic@2x.png"/>
    </el-upload>
    <div v-if='showDel&&!opreation' class="del" @click="cancel()">取消</div>
  </div>
</template>

<script>

export default {
  name: 'Uploader',
  props: {
    action: {
      type: String
    },
    item:{
      type:Object
    },
    opreation:{
      type:Boolean
    },
    name:{
      type:String,
      default:'good_picture'
    }
  },
  components: {
  },
  data () {
    return {
      isProgressing: false,
      headers: {},
      showDel: true
    }
  },
  created () {
    this.headers.token = this.$localStorage.get('token')
  },
  methods: {
    handleBeforeUpload: function () {
      this.isProgressing = true
      this.showDel = false
    },
    handleSuccess: function(response, file, fileList) {
      console.log(file)
      this.isProgressing = false
      if (response.status !== 'ok') {
        this.$message.error('上传失败：'+response.result)
        return;
      }
      let item = this.item
      this.$emit('onUploadSuccess', {
        response, file, fileList, item
      })
    },
    handleError: function(response, file, fileList) {
      this.isProgressing = false
    },
    cancel () {
      this.$emit('onUploadCancel')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">  
.del {
  padding: 0px 15px;
  display: inline-block;
  border: 1px solid #cccccc;
  font-size: 12px;
  height: 32px;
  vertical-align: bottom;
  margin-left: 10px;
  cursor: pointer;
}

img {
  padding: 10px;
  height: 90px;
  width: 90px;
  // -o-object-fit: contain;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/Uploader.vue